module.exports = __webpack_public_path__ + "img/desktop-image-hero-2.03660ebe.jpg";